var socketConnector = null;

// Must export and call initModule function to initialize socketConnector
const initModule = (socket) => {
  socketConnector = socket;
};

const apis = {
  listenIncomingMsg: (callback) => {
    return socketConnector.on("stream_message", (res) => {
      callback(res);
    });
  },
  sendMessage: (
    payload = {
      message: String,
      id: String,
    },
    callback
  ) => {
    return socketConnector.emit("message", payload, (res) => {
      callback(res);
    });
  },
  getSessionId: (callback) => {
    return socketConnector.emit("get_session_id", {}, (res) => {
      callback(res);
    });
  },
};

export default {
  initModule,
  ...apis,
};
